import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
import React from 'react';
import { Card, Icon } from 'semantic-ui-react';
import { format, parseISO } from 'date-fns';
import { Link } from 'gatsby';
import Image from '../../../../atoms/Image';
import { ensureTrailingSlash } from '../../../../modules/navigation/services/slugs';
import { ImagesPropType } from '../../../../services/proptypes';
import ObjectUtils from '../../../../utils/ObjectUtils';
import './BlogPostCard.css';
var BlogPostCard = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(BlogPostCard, _React$PureComponent);
  var _super = _createSuper(BlogPostCard);
  function BlogPostCard() {
    _classCallCheck(this, BlogPostCard);
    return _super.apply(this, arguments);
  }
  _createClass(BlogPostCard, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        slug = _this$props.slug,
        title = _this$props.title,
        publishedAt = _this$props.publishedAt,
        summary = _this$props.summary,
        heroImage = _this$props.heroImage,
        gatsbyHeroImage = _this$props.gatsbyHeroImage;
      return /*#__PURE__*/React.createElement(Link, {
        to: ensureTrailingSlash("/blog/".concat(slug))
      }, /*#__PURE__*/React.createElement(Card, {
        className: "blog-post-card"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          overflow: 'hidden'
        }
      }, /*#__PURE__*/React.createElement(Image, {
        className: "blog-post-card-image",
        src: gatsbyHeroImage || heroImage,
        wrapped: true
      })), /*#__PURE__*/React.createElement(Card.Content, null, /*#__PURE__*/React.createElement(Card.Header, null, title), ObjectUtils.isRenderable(publishedAt) && /*#__PURE__*/React.createElement(Card.Meta, null, /*#__PURE__*/React.createElement("span", {
        className: "date"
      }, format(parseISO(publishedAt), 'PPP'))), /*#__PURE__*/React.createElement(Card.Description, null, summary)), /*#__PURE__*/React.createElement(Card.Content, {
        extra: true,
        textAlign: "right"
      }, /*#__PURE__*/React.createElement("p", null, "See More", /*#__PURE__*/React.createElement(Icon, {
        name: "right arrow"
      })))));
    }
  }]);
  return BlogPostCard;
}(React.PureComponent);
export { BlogPostCard as default };
BlogPostCard.defaultProps = {
  summary: '',
  heroImage: null,
  gatsbyHeroImage: null,
  publishedAt: null
};